var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center py-1 space-y-4 justify-around animate-pulse min-h-full"},[_c('div',{staticClass:"h-4 bg-gray-200 rounded w-3/4"}),_c('div',{staticClass:"h-4 bg-gray-200 rounded w-3/4"}),_c('div',{staticClass:"h-4 bg-gray-200 rounded w-3/4"})])
}]

export { render, staticRenderFns }